var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('p',{staticClass:"medium-text ttu gray f6 tracked-mega-1 pb2"},[_vm._v("\n    "+_vm._s(_vm.labelTitle || '')+"\n  ")]),_c('p',{staticClass:"large-title-text f2 font-3-rem-ns fw9 ttu pl3"},[_vm._v("\n    "+_vm._s(_vm.body || (_vm.placeholder || ''))+"\n  ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }